// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"87b8aba4","183":"b3d93a31","233":"29663bd9","419":"76f89df9","453":"b0a8f921","469":"19f95936","827":"d6b9a88e"}[chunkId] + ".chunk.js";
};